// Hand-written TanStack route tree.
//
// We don't use `@tanstack/router-plugin` codegen yet — the route surface is
// small enough that an explicit tree keeps the build deterministic and lets
// every route file own its own `createRoute()` call. Wave 5a can adopt the
// plugin without rearranging the underlying files (they already mirror the
// file-based naming convention).

import { Route as RootRoute } from './__root';
import { Route as AuthedLayoutRoute } from './_authed/__layout';
import { Route as AuthedIndexRoute } from './_authed/index';
import { Route as AuthedOnboardingRoute } from './_authed/onboarding';
import { Route as AuthedBillingLockedRoute } from './_authed/billing-locked';
import { Route as AccountsLayoutRoute } from './_authed/accounts/__layout';
import { Route as AccountsIndexRoute } from './_authed/accounts/index';
import { Route as AccountsConnectRoute } from './_authed/accounts/connect';
import { Route as BusinessesLayoutRoute } from './_authed/businesses/__layout';
import { Route as BusinessesIndexRoute } from './_authed/businesses/index';
import { Route as BusinessesNewRoute } from './_authed/businesses/new';
import { Route as BusinessesEditRoute } from './_authed/businesses/edit';
import { Route as CampaignsLayoutRoute } from './_authed/campaigns/__layout';
import { Route as CampaignsIndexRoute } from './_authed/campaigns/index';
import { Route as CampaignsNewRoute } from './_authed/campaigns/new';
import { Route as CampaignsDetailRoute } from './_authed/campaigns/detail';
import { Route as InboxLayoutRoute } from './_authed/inbox/__layout';
import { Route as InboxIndexRoute } from './_authed/inbox/index';
import { Route as LeadsLayoutRoute } from './_authed/leads/__layout';
import { Route as LeadsIndexRoute } from './_authed/leads/index';
import { Route as RelancesLayoutRoute } from './_authed/relances/__layout';
import { Route as RelancesIndexRoute } from './_authed/relances/index';
import { Route as RelancesPendingRoute } from './_authed/relances/pending';
import { Route as SettingsLayoutRoute } from './_authed/settings/__layout';
import { Route as SettingsIndexRoute } from './_authed/settings/index';
import { Route as SettingsSectionRoute } from './_authed/settings/section';
import { Route as VoiceAccountRoute } from './_authed/voice/account';
import { Route as VoiceRelancesRedirectRoute } from './_authed/voice/relances';
import { Route as AuthForgotRoute } from './auth/forgot';
import { Route as AuthLoginRoute } from './auth/login';
import { Route as AuthResetRoute } from './auth/reset';
import { Route as AuthResendVerificationRoute } from './auth/resend-verification';
import { Route as AuthPasswordResetConfirmRoute } from './auth/password-reset/confirm';
import { Route as AuthSignUpRoute } from './auth/signup';
import { Route as AuthVerifyPendingRoute } from './auth/verify-pending';
import { Route as AuthVerifyRoute } from './auth/verify';
import { Route as AuthAccountDeletedRoute } from './auth/account-deleted';

export const routeTree = RootRoute.addChildren([
  AuthedLayoutRoute.addChildren([
    AuthedIndexRoute,
    AuthedOnboardingRoute,
    AuthedBillingLockedRoute,
    AccountsLayoutRoute.addChildren([AccountsIndexRoute, AccountsConnectRoute]),
    BusinessesLayoutRoute.addChildren([
      BusinessesIndexRoute,
      BusinessesNewRoute,
      BusinessesEditRoute,
    ]),
    CampaignsLayoutRoute.addChildren([
      CampaignsIndexRoute,
      CampaignsNewRoute,
      CampaignsDetailRoute,
    ]),
    InboxLayoutRoute.addChildren([InboxIndexRoute]),
    LeadsLayoutRoute.addChildren([LeadsIndexRoute]),
    RelancesLayoutRoute.addChildren([RelancesIndexRoute, RelancesPendingRoute]),
    VoiceAccountRoute,
    VoiceRelancesRedirectRoute,
    SettingsLayoutRoute.addChildren([SettingsIndexRoute, SettingsSectionRoute]),
  ]),
  AuthLoginRoute,
  AuthSignUpRoute,
  AuthVerifyRoute,
  AuthVerifyPendingRoute,
  AuthResendVerificationRoute,
  AuthForgotRoute,
  AuthResetRoute,
  AuthPasswordResetConfirmRoute,
  AuthAccountDeletedRoute,
]);
